import firebase from 'utils/firebase';

// TODO create unit test
export const signUpWithEmailAndPassword = history => async ({email, password}, actions) => {
  try {
    const newUser = await firebase.auth().createUserWithEmailAndPassword(email, password);
    await newUser.user.sendEmailVerification();
    history.push('/');
  } catch (error) {
    actions.setSubmitting(false);
    actions.setErrors({email: error.message});
  }
};
